<template>

  <div class="footerContainer" >
    <div style="margin: 0 auto; width:1200px">
      <div class="flexRowClass" style="">
        <div v-for="(item, index) in titleList" :key="index"  class="titleClass" @click="titleClick(item)">
          <span>{{ item.title }}</span><span v-if="index !== (titleList.length - 1)"  style="margin:0 40px;">|</span>
        </div>
      </div>

      <div class="flexRowClass" style="margin-bottom: 20px;">
        <div style="margin-right: 30px">
          <span style="margin-right: 10px">联系电话:</span>
          <span>400-1166-160（交易平台客服）0477-8322241（运营单位）</span>
        </div>
        <div style="margin-right: 30px">
          <span style="margin-right: 10px">邮箱:</span>
          <span>jxxmglsj@163.com</span>
        </div>
        <div>
          <span style="margin-right: 10px">地址:</span>
          <span>鄂尔多斯市东胜区达拉特南路3号</span>
        </div>
      </div>

      <div style="width: 100%;cfont-size: 14px;">
        <span>版权声明&nbsp;&nbsp;&nbsp;&nbsp;  </span>
        <span><el-link href="https://beian.miit.gov.cn/" target="_blank" style="text-decoration: underline"> 冀ICP备2022024858号 </el-link></span>
        <span><el-link href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13010502002114" target="_blank"
                       style="text-decoration: underline; padding-left: 20px;">
          <img src="http://www.gzzczb.com/m/test/static/images/gwab.png" style="float: left;padding-right: 5px;">
           冀公网安备 13010502002114号 </el-link>
        </span>
        <span> &nbsp;&nbsp;&nbsp;&nbsp;北京中财智采科技发展有限公司河北分公司 </span>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      titleList: [
        {
          title: '首页',
          path: '/',
        },
        {
          title: '交易信息',
          path: '/transactionInformation'
        },
        {
          title: '帮助中心',
          path: '/helpCenter'
        },
        {
          title: '下载中心',
          path: '/downloadCenter'
        },
        {
          title: '关于我们',
          path: '/aboutUs'
        },
      ]
    }
  },
  methods: {
    titleClick(item) {
      // console.log('this.$route', this.$route)
      if (this.$route.fullPath !== item.path) {
        this.$router.push(item.path)
      }
    },
  }
}
</script>

<style scoped>

.footerContainer {
  background-color: #0F0F0F;
  min-height: calc(30vh - 80px);
  padding: 30px;
  color: #999999;
  box-sizing: border-box;
}

.titleClass {
  font-size: 18px;
  /*margin: 0 40px;*/
  height: 60px;
  cursor: pointer;
  text-align: center;
}

</style>